export default {
      id: "Kinect-usage",
      viewBox: "0 0 66 36",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#Kinect",
      toString: function () {
        return this.url;
      }
    }